import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import useSize from 'components/Common/Screen/Hooks/useSize';
import Plan from './Plan';

import BuyModal from './BuyModal';

import WaitPaymentProcess from './WaitPaymentProcess';

export default function Plans({ wallet, member }) {
  const [currentPlan, setCurrentPlan] = useState(null);
  const [waitPayment, setWaitPayment] = useState(false);

  const wrapper = useRef(null);
  const size = useSize(wrapper);

  const closeModal = () => {
    setCurrentPlan(null);
  };

  let className = 'small';

  if (size && size.width > 800) {
    className = 'd-flex gap-2';
  } else if (size && size.width > 690) {
    className = 'd-flex gap-2 padding-12';
  } else if (size && size.width > 400) {
    className = 'd-grid gap-2 padding-12';
  }

  return (
    <div ref={wrapper}>
      <h4 className="mt-5">Buy What You Need (When You Need It)</h4>
      {wallet.attributes.is_network_discount && (
        <p>
          As an employee of
          {' '}
          {member.company}
          {' '}
          you receive a network discount of
          {' '}
          {wallet.attributes.network_discount}
          %
        </p>
      )}
      <div className={`${className} plans-wrapper mt-4`}>
        {Object.keys(wallet.attributes.packages).map((key) => (
          <Plan
            key={`sessions-${key}`}
            data={wallet.attributes.packages[key]}
            countSessions={parseInt(key, 10)}
            onClick={() => setCurrentPlan({
              sessions: parseInt(key, 10),
              plan: wallet.attributes.packages[key],
            })}
          />
        ))}
      </div>

      {waitPayment && <WaitPaymentProcess />}

      {currentPlan && (
      <BuyModal
        wallet={wallet}
        plan={currentPlan}
        closeModal={closeModal}
        setWaitPayment={setWaitPayment}
      />
      )}
    </div>
  );
}

Plans.propTypes = {
  wallet: PropTypes.object.isRequired,
  member: PropTypes.object.isRequired,
};
